module.exports = __webpack_public_path__ + "static/img/img_cabinet.6a96b5f1.png";